import { Theme } from "@mui/material/styles";

import { IconSize } from "@/types/mui";

export function getIconSize(theme: Theme, size: IconSize, inline: boolean = false): number {
  return inline ? theme.icon.size.inline[size] : theme.icon.size.default[size];
}
